import { render, staticRenderFns } from "./Zhhome.vue?vue&type=template&id=530d192d&scoped=true"
import script from "./Zhhome.vue?vue&type=script&lang=js"
export * from "./Zhhome.vue?vue&type=script&lang=js"
import style0 from "./Zhhome.vue?vue&type=style&index=0&id=530d192d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d192d",
  null
  
)

export default component.exports